import { DividerModule } from 'primeng/divider';
import { TreeTableModule } from 'primeng/treetable';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { TextareaModule } from 'primeng/textarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ChipModule } from 'primeng/chip';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'primeng/blockui';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
//import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { AccordionModule } from 'primeng/accordion';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { ScrollerModule } from 'primeng/scroller';
import { TableModule } from 'primeng/table';
import { NgModule } from '@angular/core';

@NgModule({
  exports: [
    TreeTableModule,
    PanelModule,
    TooltipModule,
    ContextMenuModule,
    MessagesModule,
    TieredMenuModule,
    ToggleSwitchModule,
    //TriStateCheckboxModule,
    ButtonModule,
    FileUploadModule,
    MessageModule,
    DividerModule,
    DialogModule,
    ToastModule,
    InputSwitchModule,
    SelectButtonModule,
    ProgressSpinnerModule,
    SelectModule,
    InputTextModule,
    InputNumberModule,
    InputMaskModule,
    ListboxModule,
    MultiSelectModule,
    TextareaModule,
    BlockUIModule,
    DatePickerModule,
    TabViewModule,
    AutoCompleteModule,
    ChipModule,
    AccordionModule,
    ChartModule,
    CardModule,
    ScrollerModule,
    TableModule,
  ],
})
export class PrimeNGSharedModule {}
